import { render, staticRenderFns } from "./OnboardingDomainTransferModal.vue?vue&type=template&id=2aff9d3f&scoped=true"
import script from "./OnboardingDomainTransferModal.vue?vue&type=script&lang=js"
export * from "./OnboardingDomainTransferModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingDomainTransferModal.vue?vue&type=style&index=0&id=2aff9d3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff9d3f",
  null
  
)

export default component.exports